import gsap from 'gsap';

const SlideIn = (element) => {
  const tl = gsap.timeline();
  tl.to(element.querySelector('div'), { yPercent: 0, ease: 'power3.inOut', duration: 1.2 });
};

export default SlideIn;
